import React from "react";
import "./styles/main.css";
import Icon from "../Icon";

const Loader = ({ done }) => {
	return (
		<div className="wp-loader loader">
			<div className="loader__logo-wrapper">
				<Icon id="whatsapp" className="loader__logo" />
			</div>
			<div
				className={`loader__progress ${done ? "loader__progress--done" : ""}`}
			></div>
			<h1 className="loader__title"> WhatsApp CRM</h1>
			<p className="loader__desc">
				<Icon id="lock" className="hide loader__icon" />
				Turn your WhatsApp conversations into sales.
			</p>
		</div>
	);
};

export default Loader;
